import { Heading } from '@chakra-ui/react';
import Circle from 'images/highlights/circle-5.svg';
import UnderlineImage from 'images/highlights/line-3-cross-2.svg';
import { useTranslation } from 'next-i18next';

import { TextDecorationSvg } from '@/components/functional';
import { LOCALES } from '@/utils/constants';

export const InventoryAllHeading = () => {
  const { t } = useTranslation([LOCALES.INVENTORY]);
  return (
    <Heading
      as="h1"
      color="purple.500"
      variant={{
        base: 'component-heading-large/xl',
        sm: 'component-heading-large/3xl',
        lg: 'component-heading-large/4xl',
      }}
    >
      <TextDecorationSvg variant="circle" color="lime" line={Circle}>
        {t('heading.0')}
      </TextDecorationSvg>{' '}
      {t('heading.1')}{' '}
      <TextDecorationSvg delay="1.2s" line={UnderlineImage} speed="0.5s" bottom="-50%">
        {t('heading.2')}
      </TextDecorationSvg>
    </Heading>
  );
};
